export default {
  'app.setting.pagestyle': 'Cài đặt kiểu trang',
  'app.setting.pagestyle.dark': 'Giao diện tối',
  'app.setting.pagestyle.light': 'Giao diện sáng',
  'app.setting.content-width': 'Chiều rộng nội dung',
  'app.setting.content-width.fixed': 'Cố định',
  'app.setting.content-width.fluid': 'Co giãn',
  'app.setting.themecolor': 'Màu chủ đề',
  'app.setting.themecolor.dust': 'Dust Red',
  'app.setting.themecolor.volcano': 'Volcano',
  'app.setting.themecolor.sunset': 'Sunset Orange',
  'app.setting.themecolor.cyan': 'Cyan',
  'app.setting.themecolor.green': 'Polar Green',
  'app.setting.themecolor.daybreak': 'Daybreak Blue (default)',
  'app.setting.themecolor.geekblue': 'Geek Glue',
  'app.setting.themecolor.purple': 'Golden Purple',
  'app.setting.navigationmode': 'Chế độ điều hướng',
  'app.setting.sidemenu': 'Giao diện menu bên',
  'app.setting.topmenu': 'Giao diện menu trên',
  'app.setting.fixedheader': 'Cố định tiêu đề',
  'app.setting.fixedsidebar': 'Cố định thanh bên',
  'app.setting.fixedsidebar.hint': 'Áp dụng cho giao diện menu bên',
  'app.setting.hideheader': 'Ẩn tiêu đề khi cuộn',
  'app.setting.hideheader.hint': 'Áp dụng khi bật ẩn tiêu đề',
  'app.setting.othersettings': 'Cài đặt khác',
  'app.setting.weakmode': 'Chế độ thân thiện với người mù màu',
  'app.setting.copy': 'Sao chép cài đặt',
  'app.setting.copyinfo': 'Sao chép thành công, vui lòng thay thế defaultSettings trong src/models/setting.js',
  'app.setting.production.hint':
    'Bảng cài đặt chỉ hiển thị trong môi trường phát triển, vui lòng chỉnh sửa thủ công',
};
